import styled from 'styled-components';

export const ContainerHeatmap = styled.div`
  width: ${({ imageDimensionsWidth }) => imageDimensionsWidth}px;
  height: ${({ imageDimensionsHeight }) => imageDimensionsHeight}px;
  background-image: ${({ imageSrc }) => `url(${imageSrc})`};
  background-repeat: no-repeat;
  background-size: contain;
  display: none;
`;

export const Container = styled.div`
  position: relative;
`;

export const BaseImage = styled.img`
  ${({ isBrightness }) => isBrightness && `
    filter: brightness(50%);
  `}
  max-width: 100%;
  height: auto;
`;

export const OverlayImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  height: auto;
  pointer-events: none; /* Optional: allows clicks to pass through the overlay image */
`;

export const Centered = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1em 0;
`;
